import { useCallback, useContext } from 'react';
import { BackendDispatchContext, BackendStateContext } from '../context/backend-context';

export const useDeletePodcastEpisode = () => {
  const { asyncActions } = useContext(BackendDispatchContext)
  
  return useCallback(async (id: string) => {
    return asyncActions?.deletePodcastEpisode(id)
  }, [asyncActions])
}